/** Health Report data */
export class HealthReport {
	/** Health Report id */
	id: number;
	/** Health Report user epmsPID */
	epmsPID: number;
	/** Health Report document type */
	documentType: number;
	/** Health Report document link id */
	documentLinkID: number;
	/** Health Report context id */
	contextID: string;
	/** Health Report context date */
	contextDate: string;
	/** Health Report document name */
	documentName: string;
	/** Health Report mime type */
	mimeType: string;
	/** Health Report content */
	content: string;

	/** Health Report s3 fileName */
	s3fileName: string;
}

/** Ehe Report data */
export class EheReport {
	/** Ehe Report year */
	year: any;
	/** Ehe Report data */
	report: HealthReport[];
}
